import { createFileRoute } from "@tanstack/react-router";
import TypicalTmsTreatment from "@/pages/TypicalTmsTreatment";
export const Route = createFileRoute("/contents/tms/typical-tms-treatment")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Typical TMS Treatment Course | What To Expect | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to expect during a TMS treatment course. Session duration, motor threshold mapping, 4-6 week frequency, and recovery in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Typical TMS Treatment Course | What To Expect | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to expect during a TMS treatment course. Session duration, motor threshold mapping, 4-6 week frequency, and recovery in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/tms/typical-tms-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/tms/typical-tms-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TypicalTmsTreatment />;
}
